import { createInjectionKey as e } from "../../_utils/vue/create-injection-key.js";
const c = e("n-tree-select");
export {
  c as treeSelectInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tree-select/src/interface.js
// module id = 977
// module chunks = 67